export default {
  login: {
    form: {
      username: {
        label: 'Usuario',
        placeholder: 'usuario',
      },
      password: {
        label: 'Contraseña',
        placeholder: 'contraseña',
      },
      submit: 'Iniciar sesión',
    },
    errors: {
      invalidCredentials: 'Correo electrónico y/o contraseña son incorrectos.',
    },
    forgotPassword: '¿Olvidaste tu contraseña?',
  },
  forgetPassword: {
    title: 'Por favor, ingrese su correo electrónico a continuación.',
    form: {
      email: {
        placeholder: 'Correo electrónico',
      },
      submit: 'Enviar solicitud de cambio de contraseña',
    },
    errors: {
      invalidEmail: 'Correo electrónico inválido.',
    },
    successMessage:
      '¡Le hemos enviado un correo electrónico con un enlace para restablecer su contraseña!',
  },
  recoverPassword: {
    title: 'Ingrese su nueva contraseña.',
    form: {
      email: {
        label: 'Correo electrónico',
        placeholder: 'Correo electrónico',
      },
      newPassword: {
        label: 'Nueva contraseña',
      },
      confirmPassword: {
        label: 'Confirme su nueva contraseña',
        invalid: 'Las contraseñas no coinciden.',
      },
      submit: 'Enviar',
    },
    errors: {
      typeNewPassword: 'Ingrese su nueva contraseña',
      passwordsDoNotMatch: 'Las contraseñas no coinciden.',
    },
    successMessage: '¡Contraseña cambiada con éxito!',
    login: 'Volver al inicio de sesión',
  },
  form: {
    password: {
      placeholder: '********',
    },
  },
  navbar: {
    menu: {
      profile: 'Perfil',
      settings: 'Configuración',
      logout: 'Cerrar sesión',
    },
  },
  newPassword: {
    title: 'Ingrese su nueva contraseña.',
    oldPass: 'Contraseña actual',
    newPass: 'Nueva contraseña',
    confirmNewPass: 'Confirme la nueva contraseña',
    placeholders: {
      pass: 'Contraseña',
    },
    send_button: 'Enviar',
    error_confirm: 'Las contraseñas no coinciden.',
  },
  sidebar: {
    logoAlt: 'Sistema de gestión',
    menu: {
      dashboard: 'Panel de control',

      tools: {
        generate: 'Generador de texto',
        breakText: 'Dividir texto en líneas',
        wordSeparator: 'Separador de palabras',
        specialCharacterRemover: 'Eliminador de caracteres especiales',
        wordGroups: 'Agrupador de palabras',
      },

      words: {
        title: 'Banco de palabras',
        list: 'Lista de palabras',
        import: 'Importar palabras',
        add: 'Agregar palabras',
      },

      games: {
        title: 'Juegos',

        cryptograms: {
          title: 'Criptogramas',
          list: 'Lista',
          add: 'Agregar',
        },

        crosswords: {
          title: 'Crucigramas',
          list: 'Lista',
          add: 'Agregar',
          templates: 'Lista de plantillas',
        },

        huntingWords: {
          title: 'Sopa de letras',
          list: 'Lista',
          add: 'Agregar',
        },

        shapeLinks: {
          title: 'Shape Links',
          list: 'Lista',
          add: 'Agregar',
        },

        loop: {
          title: 'Loop',
          list: 'Lista',
          add: 'Agregar',
        },

        numberSquare: {
          title: 'Number Square',
          list: 'Lista',
          add: 'Agregar',
        },

        fences: {
          title: 'Fences',
          list: 'Lista',
          add: 'Agregar',
        },

        walls: {
          title: 'Walls',
          list: 'Lista',
          add: 'Agregar',
        },

        term: {
          title: 'Término',
          list: 'Lista',
        },
      },

      users: {
        title: 'Usuarios',
        list: 'Lista',
        add: 'Agregar',
      },
    },
  },
  shared: {
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
      view: 'Ver',
      back: 'Atrás',
      save: 'Guardar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      generate: 'Generar',
      clear: 'Limpiar',
      copy: 'Copiar',
      copyText: 'Copiar texto',
      import: 'Importar',
      export: 'Exportar',
      search: 'Buscar',
      send: 'Enviar',
    },
    fonts: {
      placeholder: 'Seleccionar fuente...',
      numbers: 'Números {n}',
      symbols: 'Símbolos {n}',
      fontCrypto: 'Font Crypto {n}',
    },
    pagination: {
      summary: 'Mostrando {from} a {to} de {total} registros',
      noResults: 'Ningún resultado encontrado',
      prev: 'Anterior',
      next: 'Siguiente',
    },
    puzzle: {
      columns: {
        name: 'Nombre',
        template: 'Plantilla',
        status: 'Estado',
        level: 'Nivel',
        options: 'Opciones',
      },
      status: {
        draft: 'Borrador',
        completed: 'Finalizado',
      },
      noContent: 'Aún no hay ningún juego registrado.',
      selectGames: 'Seleccionar juegos',
      complete: 'Completar ({count})',
      export: 'Exportar ({count})',
      noSelected: 'Ningún juego seleccionado',
      sendToSite: 'Enviar al sitio ({count})',
      sendTitle: 'Enviar al sitio',
      sendConfirm:
        '¿Enviar {count} juego al sitio principal? | ¿Enviar {count} juegos al sitio principal?',
      noDraftSelected: 'Ninguno de los juegos seleccionados está en borrador.',
      game: 'juego',
      template: 'plantilla',
      deleteTitle: 'Confirme la exclusión del {label}',
      deleteMessage: '¿Está seguro de que desea eliminar el {label} "{name}"?',
    },
    confirmation: {
      title: 'Confirmar exclusión',
      message: '¿Está seguro de que desea eliminar',
    },
    gameStatus: {
      summary: '{placed} de {total} palabras {description}',
    },
    level: {
      easy: 'Fácil',
      medium: 'Medio',
      hard: 'Difícil',
    },
    export: {
      title: 'Exportar archivos',
      fileFormat: 'Formato del archivo:',
      style: 'Estilo:',
      unexpectedError: 'Ocurrió un error inesperado en la exportación.',
      noFiles: 'Ningún archivo para exportar.',
      converting: 'Convirtiendo {current} de {total} archivos...',
      conversionError:
        'Ocurrió un error durante la conversión de SVG a EPS. Por favor, inténtelo de nuevo.',
      finishing: 'Finalizando exportación...',
      types: {
        enigma: 'Enigma',
        solution: 'Solución',
        combined: 'Enigma + Solución',
        wordList: 'Lista de palabras',
        gridTxt: 'TXT de la cuadrícula',
      },
      toggles: {
        colored: 'Colorido',
        transparentBg: 'Fondo transparente',
        exportBank: 'Incluir banco de palabras',
      },
      radio: {
        arrowStyle: {
          label: 'Tipo de flecha:',
          triangle: 'Triángulo',
          filledCircle: 'Círculo relleno',
          emptyCircle: 'Círculo vacío',
          dottedCircle: 'Círculo con punto',
        },
        pathWeight: {
          label: 'Grosor de la línea:',
          thin: 'Fina',
          normal: 'Normal',
          bold: 'Gruesa',
        },
      },
    },
    distribution: {
      checkboxLabel: 'Distribuir palabras por porcentaje',
      tooltip:
        'Las palabras se distribuyen según los porcentajes. Si no hay espacio, se usarán otras direcciones.',
      placeholder: 'Número en %',
      total: 'Total:',
      mustSum100: '(la suma debe ser 100%)',
    },
    upload: {
      dropOrChoose: 'Suelte (o elija) un archivo',
      clickOrDrag: 'Haga clic o arrastre el archivo aquí',
      selectImage: 'Seleccione una imagen',
    },
    select: {
      placeholder: 'Seleccione...',
    },
    scrollToTop: {
      tooltip: 'Volver arriba',
    },
    alert: {
      seconds: 'seg.',
    },
    deletedSuccess: 'Juego eliminado con éxito',
    dashboard: {
      noResults: 'No hubo ningún resultado.',
      viewAll: 'Ver todos →',
      statusRegisters: {
        title: 'Lista de registros por estado',
      },
      lastRegisters: {
        title: 'Últimos registros',
        filters: {
          lastWeek: 'Última semana',
          today: 'Hoy',
          lastMonth: 'Último mes',
          lastYear: 'Último año',
        },
      },
      status: {
        open: 'Borrador',
        pending: 'Pendiente',
        approved: 'Aprobado',
        canceled: 'Cancelado',
        closed: 'Concluido',
      },
    },
    editor: {
      placeholder: 'Texto formateado',
    },
    input: {
      total: 'Total',
    },
    stats: {
      label: 'Etiqueta',
    },
    loader: {
      generating: 'Generando...',
      cancelled: 'Generación cancelada.',
    },
  },
};
